"use client";

import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { ReactNode } from "react";

interface RecaptchaProviderProps {
  children: ReactNode;
  public_site_key: string;
}

export function ReCaptchaProvider({
  children,
  public_site_key,
}: RecaptchaProviderProps) {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={public_site_key ?? ""}
      useRecaptchaNet={true}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
      }}
      container={{
        parameters: {
          badge: "bottomright",
        },
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
}
